export enum CoffeeOrderStatus {
  NEW = 'New',
  READY = 'Ready',
  PICKED_UP = 'PickedUp',
  CANCELLED = 'Cancelled',
}

export enum CoffeeDrink {
  ESPRESSO = 'Espresso',
  AMERICANO = 'Americano',
  LATTE = 'Latte',
  FLAT_WHITE = 'FlatWhite',
  MOCHA = 'Mocha',
  CAPPUCCINO = 'Cappuccino',
  // FMIAPP-237: added for the three-drink menu (Long black / Flat white / Latte).
  // The older members stay so historical rows still parse (D-3).
  LONG_BLACK = 'LongBlack',
}

// FMIAPP-237: the single customer option. Size/Milk/Strength/Decaf were removed
// from the contract (D-2).
export enum CoffeeFlavour {
  NESPRESSO = 'Nespresso',
  STARBUCKS = 'Starbucks',
}
